"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var RandomGenerator_1, _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomGenerator = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../container/ServiceIdentifiers");
const md5_1 = __importDefault(require("md5"));
const chance_1 = require("chance");
const IOptions_1 = require("../interfaces/options/IOptions");
const ISourceCode_1 = require("../interfaces/source-code/ISourceCode");
const Initializable_1 = require("../decorators/Initializable");
const AlphabetString_1 = require("../constants/AlphabetString");
const AlphabetStringUppercase_1 = require("../constants/AlphabetStringUppercase");
let RandomGenerator = RandomGenerator_1 = class RandomGenerator {
    constructor(sourceCode, options) {
        this.sourceCode = sourceCode;
        this.options = options;
    }
    initialize() {
        this.randomGenerator = new chance_1.Chance(this.getRawSeed());
    }
    getMathRandom() {
        return this.getRandomInteger(0, 99999) / 100000;
    }
    getRandomGenerator() {
        return this.randomGenerator;
    }
    getRandomInteger(min, max) {
        return this.getRandomGenerator().integer({
            min: min,
            max: max
        });
    }
    getRandomIntegerExcluding(min, max, valuesToExclude) {
        const valuesToPickArray = [];
        for (let value = min; value <= max; value++) {
            if (valuesToExclude.includes(value)) {
                continue;
            }
            valuesToPickArray.push(value);
        }
        return this.randomGenerator.pickone(valuesToPickArray);
    }
    getRandomString(length, pool = RandomGenerator_1.randomGeneratorPool) {
        return this.getRandomGenerator().string({ length, pool });
    }
    getInputSeed() {
        return this.options.seed.toString();
    }
    getRawSeed() {
        const inputSeed = this.getInputSeed();
        const inputSeedParts = `${inputSeed}`.split('|');
        if (inputSeedParts.length > 1) {
            return inputSeed;
        }
        const sourceCodeMD5Hash = md5_1.default(this.sourceCode.getSourceCode());
        return `${inputSeed}|${sourceCodeMD5Hash}`;
    }
};
RandomGenerator.randomGeneratorPool = `${AlphabetString_1.alphabetString}${AlphabetStringUppercase_1.alphabetStringUppercase}`;
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", typeof (_a = typeof chance_1.Chance !== "undefined" && chance_1.Chance.Chance) === "function" ? _a : Object)
], RandomGenerator.prototype, "randomGenerator", void 0);
__decorate([
    inversify_1.postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RandomGenerator.prototype, "initialize", null);
RandomGenerator = RandomGenerator_1 = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.ISourceCode)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_b = typeof ISourceCode_1.ISourceCode !== "undefined" && ISourceCode_1.ISourceCode) === "function" ? _b : Object, typeof (_c = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _c : Object])
], RandomGenerator);
exports.RandomGenerator = RandomGenerator;
